<template>
    <div>
        <v-tabs            
            v-model="tabs"                    
        >
            <v-tab
                v-for="item in itemsTabs"
                :key="item.key"
            >
                {{ item.label }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs">
            <v-tab-item
                class="p-1"
                v-for="item in itemsTabs"
                :key="item.key"
            >                  
                <v-card
                    class="mx-auto mt-4"
                    style="min-height:500px;"
                >
                    <SGPDynamicImportComponent 
                        :pathFile="item.pathComponent" 
                        :ref="item.key"
                        :propsPage="propsPage"
                    />
                </v-card>                        
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
export default {
    name: 'SGPTabsMenuHorizontalComponent',

    data () {
      return {
        tabs: null      
      }
    },

    props: { 
        itemsTabs : {
            type: Array,
            required: true
        },
        propsPage : {
            type: Object,
            required: true
        }
    }    
}
</script>

<style>
.v-tab {
    text-transform: none !important;    
}

.v-slide-group__wrapper {
    border-bottom: 1px solid #0000001c;
}
</style>
